export const PMSValue = ({ value }: { value: string | undefined }) => {
  return (
    <p className="text-content-200 font-medium text-sm">
      PMS Value: {value ?? "N/A"}
    </p>
  );
};
